import React from 'react';

import { Navbar } from './components';

export default function Header(): React.ReactNode {
  return (
    <header className='fixed z-30 w-full top-0 print:hidden'>
      <Navbar />
    </header>
  );
}
